export default __webpack_public_path__ + "static/logo-team-six-569109cd61d73337ea3ef9f85a671818.svg";